import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Account } from '@personal-area/global/accounts/models';
import { AccountActionsService } from '@personal-area/global/accounts/ui';

@Component({
    selector: 'global-demo-funds-button',
    templateUrl: './demo-funds-button.component.html',
    styleUrls: ['./demo-funds-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DemoFundsButtonComponent {
  @Input() account?: Account;

  constructor(public accountActionsService: AccountActionsService) {}
}
